<template>
  <div>
    <md-button
      class="md-primary md-raised"
      :disabled="!isAddAppointmentEnabled"
      @click="addAppointment"
      >Add Appointment</md-button
    >
  </div>
</template>

<script>
import { eventBus } from "../../../eventbus";
export default {
  name: "AddAppointmentDialogAction",
  data: function () {
    return {
      isAddAppointmentEnabled: false,
    };
  },
  methods: {
    addAppointment: function () {
      eventBus.onAddAppointmentClick();
      this.$router.push(this.$route.path + "/added");
    },
    addAppointmentFormValidationListener: function (isValid) {
      this.isAddAppointmentEnabled = isValid;
    },
  },
  created: function () {
    eventBus.$on(
      "add-appointment-form-validation",
      this.addAppointmentFormValidationListener
    );
  },
  beforeDestroy: function () {
    eventBus.$off(
      "add-appointment-form-validation",
      this.addAppointmentFormValidationListener
    );
  },
};
</script>

<style>
</style>